export default async (context:any, payload:any) => {
    const target = payload.targetId.substring(payload.targetId.indexOf('_') + 1);
    const targetValue = context.rootState[payload.targetId].value;

    context.commit('SET_PATH_PARAM', {
        key: target,
        value: targetValue,
    });

    await context.dispatch('call', payload, { root: true });

    // Set selected job once single job remains while filtering by task, location, tool, and/or variation
    const jobs = context.rootState.appState.data.jobs;
    if (jobs.length === 1) {
        context.commit('appState/SET_VALUE', {
            key: 'selectedJob',
            value: jobs[0],
        }, {
            root: true,
        });
    } else {
        context.commit('appState/SET_VALUE', {
            key: 'selectedJob',
            value: null,
        }, {
            root: true,
        });
    }
};